import React from 'react';
import { Grid } from '@material-ui/core';
import { Carousel } from 'react-responsive-carousel';
import { CheckIcon } from '../../../components/icon/solid';
import { HelpDocAction, IntercomComponent } from '../../../components';
import { useTitle } from '../../../hooks';
import useStyles from './styles';
import lightHouseArticles from '../../../configs/lightHouseArticles';
import PricingPageTitle from './components/PricingPageTitle/PricingPageTitle';
import IntroPricingPageTableHeader from './components/PricingPageTableHeaders/IntroPricingPageTableHeader';
import TrialPricingPageTableHeader from './components/PricingPageTableHeaders/TrialPricingPageTableHeader';
import TeleprompterPricingPageTableHeader
  from './components/PricingPageTableHeaders/TeleprompterPricingPageTableHeader';
import PricingColumn from './components/PricingColumn';
import ProPackagesPricingPageTableHeader from './components/PricingPageTableHeaders/ProPackagesPricingPageTableHeader';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

const PricingMobile = () => {
  const classes = useStyles();
  useTitle('Pricing');
  const included = <CheckIcon className={classes.checkIcon} />;
  const notIncluded = '—';

  return (
    <Grid container className={classes.container}>
      <Grid item className={classes.content}>
        <PricingPageTitle />
        <Carousel
          showArrows
          showThumbs={false}
          showIndicators={false}
          showStatus={false}
        >
          <div className={classes.mobileItem}>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem}`}>
              <IntroPricingPageTableHeader isMobile={true}/>
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem}`}>
              <PricingColumn
                text="ClipPress"
                infoBlock="ClipPress is a tool with video planning (script writing, editor instructions) and studio
               (teleprompter, recording) functions."
              />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem}`}>
              <PricingColumn
                text="Active Projects"
                infoBlock="Number of projects that can be actively worked on at a time."
              />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem}`}>
              <PricingColumn
                text="MP4 video download"
                infoBlock="Ability to download all MP4 files used in the video production process, including final
               outputs."
              />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem}`}>
              <PricingColumn
                text="Video hosting on PitchHub.com"
                infoBlock="Video hosted on the PitchHub.com web site" />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem} ${classes.tableMobileXSItem}`}>
              <PricingColumn
                text="Video playback on 3rd party site"
                infoBlock="Video hosting for streaming playback website separate from PitchHub.com"
              />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem} ${classes.tableFirstTitleColumnItem}`}>
              <PricingColumn text="Additional Services" titleBlock />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem}`}>
              <PricingColumn
                text="Editing - first 5 playback minutes"
                infoBlock={'A "playback minute" is one minute of playback for the the final, edited video.'}
              />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem} ${classes.tableMobileSMItem}`}>
              <PricingColumn
                text="Editing - each additional playback minute"
                infoBlock={'A "playback minute" is one minute of playback for the the final, edited video.'}
              />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem}`}>
              <PricingColumn
                text="Formatted captions"
                infoBlock="Captions that are formatted with your branding colors."
              />
            </div>
            <div className={`${classes.tableItem} ${classes.tableMobileFirstColumnItem}`}>
              <PricingColumn
                text="Enterprise Branding"
                infoBlock="Includes video graphics overlays which are designed with your logo and branding colors." />
            </div>
          </div>

          <div className={classes.mobileItem}>
            <div className={classes.tableItem}><TrialPricingPageTableHeader /></div>
            <div className={classes.tableItem}><PricingColumn text={included} /></div>
            <div className={classes.tableItem}><PricingColumn text="1" /></div>
            <div className={classes.tableItem}><PricingColumn text={included} /></div>
            <div className={classes.tableItem}><PricingColumn text={notIncluded} /></div>
            <div className={`${classes.tableItem} ${classes.tableMobileXSItem}`}><PricingColumn text={notIncluded} /></div>
            <div className={classes.tableItem}><PricingColumn text="Intro" titleBlock /></div>
            <div className={classes.tableItem}><PricingColumn text="$89" /></div>
            <div className={`${classes.tableItem} ${classes.tableMobileSMItem}`}><PricingColumn text="$10" /></div>
            <div className={classes.tableItem}><PricingColumn text="included" /></div>
            <div className={classes.tableItem}><PricingColumn text="Contact for quote" /></div>
          </div>

          <div className={classes.mobileItem}>
            <div className={classes.tableItem}><TeleprompterPricingPageTableHeader /></div>
            <div className={classes.tableItem}><PricingColumn text={included} /></div>
            <div className={classes.tableItem}><PricingColumn text="unlimited" /></div>
            <div className={classes.tableItem}><PricingColumn text={included} /></div>
            <div className={classes.tableItem}><PricingColumn text={notIncluded} /></div>
            <div className={classes.tableItem}><PricingColumn text={notIncluded} /></div>
            <div className={`${classes.tableItem} ${classes.tableMobileXSItem}`}><PricingColumn text="—" /></div>
            <div className={classes.tableItem}><PricingColumn text="Teleprompter" titleBlock /></div>
            <div className={classes.tableItem}><PricingColumn text="included" /></div>
            <div className={`${classes.tableItem} ${classes.tableMobileSMItem}`}><PricingColumn text="$10" /></div>
            <div className={classes.tableItem}><PricingColumn text="included" /></div>
            <div className={classes.tableItem}><PricingColumn text="Contact for quote" /></div>
          </div>

          <div className={classes.mobileItem}>
            <div className={classes.tableItem}><ProPackagesPricingPageTableHeader /></div>
            <div className={classes.tableItem}><PricingColumn text={included} /></div>
            <div className={classes.tableItem}><PricingColumn text="unlimited" /></div>
            <div className={classes.tableItem}><PricingColumn text={included} /></div>
            <div className={classes.tableItem}><PricingColumn text={included} /></div>
            <div className={`${classes.tableItem} ${classes.tableMobileXSItem}`}><PricingColumn text={included} /></div>
            <div className={classes.tableItem}><PricingColumn text="Pro Packages" titleBlock /></div>
            <div className={classes.tableItem}><PricingColumn text="included" /></div>
            <div className={`${classes.tableItem} ${classes.tableMobileSMItem}`}><PricingColumn text="$10" /></div>
            <div className={classes.tableItem}><PricingColumn text="included" /></div>
            <div className={classes.tableItem}><PricingColumn text="Contact for quote" /></div>
          </div>
        </Carousel>
        <Grid item container justify="center" style={{ marginTop: 20 }}>
          <HelpDocAction
            title={'"Pay As You Go" example'}
            id={lightHouseArticles.billing}
          />
        </Grid>
        <div style={{ height: '100px' }} />
      </Grid>
      <IntercomComponent />
    </Grid>
  );
};

export default PricingMobile;
